import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';
import { $t } from '#/locales';

const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:finance',
      order: 5,
      title: '财务管理',
      keepAlive: true,
    },
    path: '/workspace',
    redirect: '/workspace/finance/recharge',
    name: 'Workspace',
    children: [
      {
        // 兼容旧默认首页路径，菜单已迁至「概况」
        name: 'WorkspaceHomeLegacy',
        path: 'home',
        redirect: '/dashboard/home',
        meta: {
          hideInMenu: true,
          hideInTab: true,
          title: '首页',
        },
      },
      {
        name: 'User',
        path: 'user',
        component: () => import('#/views/workspace/user/index.vue'),
        meta: {
          icon: 'lucide:area-chart',
          title: $t('page.dashboard.userInfo'),
          keepAlive: true,
          hideInMenu: true,
        },
      },
      {
        name: 'OpenPlatform',
        path: 'open-platform',
        component: () => import('#/views/workspace/open-platform/index.vue'),
        meta: {
          hideInMenu: true,
          title: '开放平台',
        },
      },
      {
        name: 'ImageSpace',
        path: 'image-space',
        component: () => import('#/views/workspace/image-space/index.vue'),
        meta: {
          hideInMenu: true,
          title: '图片空间',
        },
      },
      {
        name: 'Order',
        path: 'order',
        redirect: '/old-system/order',
        meta: {
          hideInMenu: true,
          title: $t('page.dashboard.order'),
        },
      },
      {
        name: 'RefundManage',
        path: 'refundManage',
        redirect: '/old-system/refund-manage',
        meta: {
          hideInMenu: true,
          title: '售后管理',
        },
      },
      {
        name: 'TKRefund',
        path: 'tkRefund',
        redirect: '/old-system/tk-refund',
        meta: {
          hideInMenu: true,
          title: '退款列表',
        },
      },
      {
        name: 'TKGoods',
        path: 'tkgoods',
        redirect: '/old-system/tk-goods',
        meta: {
          hideInMenu: true,
          title: '商品列表',
        },
      },
      {
        name: 'Finance',
        path: 'finance',
        redirect: '/workspace/finance/recharge',
        meta: {
          title: $t('page.dashboard.finance'),
          keepAlive: true,
          hideInMenu: true,
        },
      },
      {
        name: 'FinanceRecharge',
        path: 'finance/recharge',
        component: () =>
          import('#/views/workspace/client-finance/recharge.vue'),
        meta: {
          icon: 'lucide:badge-dollar-sign',
          title: '充值管理',
          keepAlive: true,
          order: 1,
        },
      },
      {
        name: 'FinanceDetails',
        path: 'finance/details',
        component: () => import('#/views/workspace/client-finance/details.vue'),
        meta: {
          icon: 'lucide:receipt-text',
          title: '财务明细',
          keepAlive: true,
          order: 2,
        },
      },
      {
        name: 'TicketCenter',
        path: 'ticket',
        redirect: '/market/ticket',
        meta: {
          hideInMenu: true,
          title: '工单中心',
        },
      },
      {
        name: 'TicketDetail',
        path: 'ticket/:id',
        redirect: (to) => `/market/ticket/${to.params.id}`,
        meta: {
          hideInMenu: true,
          title: '工单详情',
        },
      },
    ],
  },
  {
    component: BasicLayout,
    meta: {
      hideInMenu: true,
      icon: 'mdi:archive-clock-outline',
      order: 7,
      title: '旧系统菜单',
      keepAlive: true,
    },
    path: '/old-system',
    redirect: '/old-system/order',
    name: 'OldSystemMenu',
    children: [
      {
        name: 'OldSystemOrder',
        path: 'order',
        component: () => import('#/views/workspace/order/index.vue'),
        meta: {
          icon: 'mdi:list-box',
          title: '订单管理',
          keepAlive: true,
          order: 1,
        },
      },
      {
        name: 'OldSystemRefundManage',
        path: 'refund-manage',
        component: () => import('#/views/workspace/order/refundmanage.vue'),
        meta: {
          icon: 'mdi:list-box',
          title: '售后管理',
          keepAlive: true,
          order: 2,
        },
      },
      {
        name: 'OldSystemAuthOrder',
        path: 'auth-order',
        component: () => import('#/views/market/order/tk.vue'),
        meta: {
          icon: 'mdi:invoice-text-arrow-left',
          title: '授权订单',
          keepAlive: true,
          order: 3,
        },
      },
      {
        name: 'OldSystemTKRefund',
        path: 'tk-refund',
        component: () => import('#/views/workspace/order/refund.vue'),
        meta: {
          affixTab: true,
          icon: 'mdi:credit-card-refund',
          title: '退款列表',
          keepAlive: true,
          order: 4,
          authority: ['test'],
        },
      },
      {
        name: 'OldSystemTKGoods',
        path: 'tk-goods',
        component: () => import('#/views/goods/tkgoods.vue'),
        meta: {
          affixTab: true,
          icon: 'lsicon:goods-filled',
          title: '商品列表',
          keepAlive: true,
          order: 5,
          authority: ['test'],
        },
      },
    ],
  },
  {
    path: '/workspace/authOrder',
    redirect: '/old-system/auth-order',
    meta: { hideInMenu: true, title: '授权订单' },
  },
  {
    path: '/workspace/distributor-recharge-audit',
    redirect: '/workspace/finance/recharge',
    meta: { hideInMenu: true, title: '客户充值审核' },
  },
  {
    path: '/workspace/distributor-earnings',
    redirect: '/workspace/finance/details',
    meta: { hideInMenu: true, title: '我的收益' },
  },
  {
    path: '/workspace/distributor-customer-accounts',
    redirect: '/workspace/finance/details',
    meta: { hideInMenu: true, title: '客户账户概览' },
  },
  {
    path: '/workspace/distributor-settings',
    redirect: '/workspace/finance/recharge',
    meta: { hideInMenu: true, title: '我的分销配置' },
  },
];

export default routes;
